export const idValidationStatuses = {
  DISAPPROVED: 'DISAPPROVED',
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
};
